import { render } from "./RaterBubble.vue?vue&type=template&id=6ede0486&scoped=true"
import script from "./RaterBubble.vue?vue&type=script&lang=ts"
export * from "./RaterBubble.vue?vue&type=script&lang=ts"

import "./RaterBubble.vue?vue&type=style&index=0&id=6ede0486&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-6ede0486"

export default script